<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_acc_white_card.detail_title')">
    <template #content>
      <v-container v-if="checkInRecord"
                   fluid>
        <v-text-field readonly
                      :label="$t('admin_acc_white_card.id')"
                      :value="`A${checkInRecord.white_card.id.toString().padStart(5, '0')}`"></v-text-field>

        <v-expansion-panels multiple
                            v-model="openedPanels">
          <v-expansion-panel>
            <v-expansion-panel-header>{{ $t('admin_acc_white_card.bookings') }} ({{ checkInRecord.bookings.length }})</v-expansion-panel-header>
            <v-expansion-panel-content>
              <AdminBookingList :display-items="checkInRecord.bookings"
                                hide-search
                                hide-actions></AdminBookingList>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>{{ $t('admin_acc_white_card.gym_check_ins') }} ({{ checkInRecord.gym_checkins.length }})</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table :items="checkInRecord.gym_checkins"
                            :headers="gymCheckInRecordHeaders">
                <template v-slot:item.checkin_time="{value}">
                  {{ $parseDate(value, 'yyyy-MM-dd HH:mm:ss') }}
                </template>
                <template v-slot:item.checkout_time="{value}">
                  {{ $parseDate(value, 'yyyy-MM-dd HH:mm:ss') }}
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               @click="checkOut"
               class="mr-3"
               depressed
               large
               :disabled="!checkInRecord || checkInRecord.checkout_at">
          {{ $t('admin_acc_white_card.check_out_title') }}
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>

<script>
import {ref, watch} from "@vue/composition-api";
import BGModal from "@/components/BGModal";
import AdminBookingList from "@/components/acc_booking/booking/AdminBookingList";

export default {
  name: 'WhiteCardActiveRecordModal',
  components: {AdminBookingList, BGModal},
  props: {
    shown: Boolean,
    recordId: String,
    record: Object,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          if (props.record) {
            checkInRecord.value = props.record;
          } else {
            getCheckInRecord();
          }
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    //
    const openedPanels = ref([0, 1]);
    const checkInRecord = ref(null);
    const getCheckInRecord = function () {
      root.$callAPI('aafb/admin/white_card/records/', {record_id: props.recordId}, (response) => {
        checkInRecord.value = response.body.record;
      })
    };
    const gymCheckInRecordHeaders = ref([
      {text: root.$t('gym_subscription.checkin_time'), value: 'checkin_time'},
      // {text: root.$t('gym_subscription.checkout_time'), value: 'checkout_time'},
      {text: root.$t('gym_subscription.type'), value: 'subscription.type.name'},
    ]);

    const checkOut = async function () {
      // if (confirm(root.$t('admin_acc_white_card.check_out_confirm_msg'))) {
        root.$callAPI('aafb/admin/white_card/checkout/', {
          white_card_id: checkInRecord.value.white_card.id,
        }, () => {
          root.$showAlertMessage(root.$t('admin_acc_white_card.check_out_success_msg'));
          cancel()
        });
      // }
    };

    return {
      dialogShown,
      cancel,

      openedPanels,
      checkInRecord,
      gymCheckInRecordHeaders,

      checkOut,
    }
  }
}
</script>
